var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeadphones = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.077 6.4C12.3977 6.47463 11.9488 7.84677 11.9488 8.53333V10.6667C11.9253 11.3333 12.5834 11.7333 13.1945 11.7333H14.2052C14.9771 11.7333 15.3334 11.4129 15.3334 10.6667V8.53333C15.3334 7.84677 14.8999 6.47463 14.2052 6.4C14.2052 3.13134 11.9452 0 8.56418 0C5.18313 0 1.79495 3.13134 1.79495 6.4C1.11565 6.47463 0.666748 7.84677 0.666748 8.53333V10.6667C0.666748 11.4129 1.02302 11.7333 1.79495 11.7333H2.92316C3.69509 11.7333 4.05136 11.4129 4.05136 10.6667V8.53333C4.05136 7.84677 3.6179 6.47463 2.92316 6.4C2.92316 3.65373 5.72348 1.06667 8.56418 1.06667C11.4049 1.06667 13.077 3.65373 13.077 6.4Z",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43598 13.8667C6.95738 13.8667 6.30777 14.4706 6.30777 14.9333C6.30777 15.396 6.95738 16 7.43598 16H8.56418C8.98103 16 9.6152 15.3214 9.69239 14.9333C11.299 14.5135 12.1351 13.4359 12.8762 12.0553C12.4933 12.0123 12.3274 11.9231 11.9853 11.6948C11.3523 12.7843 10.9584 13.4935 9.69239 13.8667C9.56888 13.5682 8.91927 13.8667 8.56418 13.8667H7.43598Z",
    fill: "#908CA0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeadphones);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/headphones.eb82f799cbfb02b864cd0d17bf8d6786.svg";